import CustomScrollBar from './CustomScrollBar';
export default CustomScrollBar;